
import React from 'react';
import './KpiTile.css';

interface Props {
  label: string;
  value: string;
  delta?: string;
  deltaUp?: boolean;
  icon?: string;
  accent?: string;
}

export default function KpiTile({ label, value, delta, deltaUp, icon, accent = 'var(--color-ocean-500)' }: Props) {
  return (
    <div className="kpi-tile">
      <div className="kpi-tile__top">
        <span className="kpi-tile__label">{label}</span>
        {icon && <span className="kpi-tile__icon" style={{ color: accent }}>{icon}</span>}
      </div>
      <div className="kpi-tile__value">{value}</div>
      {delta && (
        <div className={`kpi-tile__delta${deltaUp ? ' kpi-tile__delta--up' : ' kpi-tile__delta--down'}`}>
          <span className="kpi-tile__delta-chip">
            {deltaUp ? '↑' : '↓'} {delta}
          </span>
          <span className="kpi-tile__delta-label">vs last month</span>
        </div>
      )}
    </div>
  );
}
